<template>
    <el-dialog title="操作部" :visible.sync="dialogVisible" width="60%" top="4vh">
        <div class="box-card" v-if="infoContent && Object.keys(infoContent).length">
            <template v-if="infoContent.productInfos.length">
                <el-row class="custom-container" v-for="item in infoContent.productInfos" :key="item.id">
                    <el-col :span="4">
                        <el-image
                            style="width: 100%; height: 100%;"
                            :src="item.imageUrl"
                            :preview-src-list="item.imageUrl.split(',')"
                        ></el-image>
                    </el-col>
                    <el-col :span="18" :offset="2">
                        <div class="inform flex">
                            <div class="title">亚马逊订单号：</div>
                            <div>{{ infoContent.amazonOrderId }}</div>
                        </div>
                        <div class="inform flex">
                            <div class="title">标题：</div>
                            <div>{{ item.title }}</div>
                        </div>
                        <div class="inform flex">
                            <div class="title">SKU：</div>
                            <div>{{ item.sku }}</div>
                        </div>
                        <el-row type="flex" justify="space-between">
                            <div class="inform flex">
                                <div class="title">数量：</div>
                                <div>{{ infoContent.purchaseQuantity }}</div>
                            </div>
                            <!-- <el-button type="text">打印（0）</el-button> -->
                        </el-row>
                    </el-col>
                </el-row>
            </template>
            <div class="custom-container" v-if="infoPurchase.length">
                <div style="width:100%;">
                    <template v-for="item in infoPurchase">
                        <div style="width:100%;" :key="item.purchaseNumber">
                            <el-divider></el-divider>
                            <el-row>
                                <el-col :span="8">
                                    <div class="inform">采购单据号：{{ item.purchaseNumber }}</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="inform">运单号：{{ item.internalConveyNumber }}</div>
                                </el-col>
                            </el-row>
                            <div class="inform">海逊仓库核对详情：{{ item.purchaseModel }}</div>
                            <el-row>
                                <el-col :span="8">
                                    <div class="inform">入库尺寸：{{ item.purchaseSize }}</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="inform">入库重量：{{ item.purchaseWeight }}</div>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <div class="inform">材积重：{{ item.purchaseSize }}</div>
                                </el-col>
                                <el-col :span="8">
                                    <div class="inform">计费重：{{ item.purchaseWeight }}</div>
                                </el-col>
                            </el-row>
                        </div>
                    </template>
                </div>
            </div>
        </div>
      <div v-else-if="infoData.productInfos && infoData.productInfos.length">
        <el-row class="custom-container" v-for="item in infoData.productInfos" :key="item.id">
          <el-col :span="4">
            <div v-if="item.imageUrl">
              <el-image
                  style="width: 100%; height: 100%;"
                  :src="item.imageUrl"
                  :preview-src-list="item.imageUrl.split(',')"
              ></el-image>
            </div>
            <el-row type="flex" justify="center" align="middle" v-else>
              <el-button type="text" size="mini" @click="getOriginalImg(item)">查看原图</el-button>
            </el-row>
          </el-col>
          <el-col :span="18" :offset="2">
            <div class="inform flex">
              <div class="title">亚马逊订单号：</div>
              <div>{{ item.amazonOrderId }}</div>
            </div>
            <div class="inform flex">
              <div class="title">标题：</div>
              <a target="_blank" style="color: #7fb1ff" :href="item.sourceLink">{{ item.title }}</a>
            </div>
            <!--            <div class="inform flex">-->
            <!--              <div class="title">SKU：</div>-->
            <!--              <div>{{ item.sku }}</div>-->
            <!--            </div>-->
            <el-row type="flex" justify="space-between">
              <div class="inform flex">
                <div class="title">数量：</div>
                <div>{{ item.quantityOrdered }}</div>
              </div>
              <!-- <el-button type="text">打印（0）</el-button> -->
            </el-row>
          </el-col>
        </el-row>
      </div>
      <template v-if="infoData.inventoryOperates && infoData.inventoryOperates.length">
        <div v-for="item in infoData.inventoryOperates" :key="item.id">
          <el-divider></el-divider>
          <el-row class="custom-container" type="flex" align="middle">
            <el-col :span="4">
              <el-image :src="item.imagesList[0]"></el-image>
            </el-col>
            <el-col :offset="1">
              <div class="inform flex"><span class="title">库存编号：</span>{{ item.inventoryNumber }}</div>
              <div class="inform flex"><span class="title">全称：</span>{{ item.productFullName }}</div>
              <div class="inform flex"><span class="title">仓库名称：</span>{{ item.warehouseName }}</div>
              <div class="inform flex"><span class="title">货架编号：</span>{{ item.shelfNumber }}</div>
              <div class="inform flex"><span class="title">使用数量：</span>{{ item.useCount }}</div>
            </el-col>
          </el-row>
        </div>
      </template>
            <div class="custom-container">
                <div style="width:100%;">
                    <el-divider></el-divider>
                    <el-row type="flex">
                        <div class="inform" style="flex-shrink:0;line-height:50px;">包材设置：</div>
                        <div style="width:90%;">
                            <el-col
                                class="inform"
                                :span="20"
                                style="padding: 10px 0px;"
                                v-for="(item, index) in infoData.orderPackPrices"
                                :key="index"
                            >
                                <el-col :span="5">
                                    <el-select v-model="item.packId" placeholder="请选择">
                                        <el-option
                                            v-for="(item,index) in bagLists"
                                            :key="index"
                                            :label="item.priceName"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="2" :offset="1">数量：</el-col>
                                <el-col :span="2">
                                    <el-input v-model="item.packCount"></el-input>
                                </el-col>
                                <el-col :span="3" :offset="1">{{ calcPrice(item) }}CNY</el-col>
                                <el-col :span="4" :offset="1">
                                    <el-button type="primary" @click="Add_Packing_materials(index)" v-if="index === 0">
                                        添加
                                    </el-button>
                                    <el-button
                                        type="danger"
                                        @click="Packingmaterialsdele(index)"
                                        v-if="index !== 0 && infoData.orderPackPrices.length > 1"
                                    >
                                        删除
                                    </el-button>
                                </el-col>
                                <!-- <el-col :span="4">类型：{{ item.priceName }}</el-col>
                                <el-col :span="4" :offset="1">数量：{{ item.packCount }}</el-col>
                                <el-col :span="4" :offset="1">{{ item.priceValueTotal }}CNY</el-col> -->
                            </el-col>
                        </div>
                    </el-row>
                </div>
            </div>
            <div class="custom-container" v-if="infoChannel.length">
                <div style="width:100%;">
                    <el-divider></el-divider>
                    <div class="inform">
                        <span style="margin-right:10px;">渠道信息：</span>
                    </div>
                    <div v-if="infoChannel.length">
                        <el-card shadow="hover" v-for="item in infoChannel" :key="item.id">
                            <el-row type="flex">
                                <div class="channel-flex">
                                    <h4>渠道：</h4>
                                    <span v-if="item.type == 1">三态</span>
                                    <span v-if="item.type == 2">云途</span>
                                    <span v-if="item.type == 3">燕文</span>
                                    <span v-if="item.type == 4">第三方</span>
                                    <span v-if="item.type == 5">k5</span>
                                    <span v-if="item.type == 6">递四方</span>
                                    <span v-if="item.type == 7">云途（服装）</span>
                                    <span v-if="item.type == 8">泰嘉</span>
                                    <span v-if="item.type == 9">八达通</span>
                                    <span v-if="item.type == 10">云途A</span>
                                    <span v-if="item.type == 11">递四方A</span>
                                    <span v-if="item.type == 12">捷岸</span>
                                    <span v-if="item.type == 13">立德</span>
                                    <span v-if="item.type == 14">艾姆勒</span>
                                    <span v-if="item.type == 15">shopee物流</span>
                                    <span v-if="item.type == 16">ozon物流</span>
                                    <span v-if="item.type == 17">柏电</span>
                                    <span v-if="item.type == 18">柏电自有</span>
                                    <span v-if="item.type == 19">万立德</span>
                                    <span v-if="item.type == 20">浩亿达</span>
                                    <span v-if="item.type == 21">Cheer</span>
                                    <span v-if="item.type == 22">辰达通</span>
                                    <span v-if="item.type == 23">辰达通A</span>
                                    <span v-if="item.type == 24">浩亿达_厦门</span>
                                    <span v-if="item.type == 25">艾派</span>
                                    <span v-if="item.type == 26">艾派_厦门</span>
                                    <span v-if="item.type == 27">dealfy</span>
                                    <span v-if="item.type == 28">菜鸟</span>
                                    <span v-if="item.type == 29">艾派COD</span>
                                    <span v-if="item.type == 30">欧邮通</span>
                                    <span v-if="item.type == 31">菜鸟-海度</span>
                                    <span v-if="item.type == 32">速卖通物流</span>
                                    <span v-if="item.type == 33">Walmart_SWW</span>
                                    <span v-if="item.type == 34">商壹国际</span>
                                    <span v-if="item.type == 35">小包</span>
                                    <span v-if="item.type == 36">mercadolibre物流</span>
                                </div>
                                <div class="channel-flex">
                                    <h4>运单号：</h4>
                                    {{ item.conveyNumber }}
                                </div>
                                <div class="channel-flex">
                                    <h4>追踪号：</h4>
                                    {{ item.trackNumber }}
                                </div>
                                <div class="channel-flex">
                                    <h4>转单号：</h4>
                                    {{ item.transferOrderNumber }}
                                </div>
                            </el-row>
                            <el-row type="flex" justify="space-between">
                                <el-row type="flex">
                                    <div class="channel-flex">
                                        <h4>国家：</h4>
                                        {{ item.countryName }}
                                    </div>
                                    <div class="channel-flex">
                                        <h4>路线：</h4>
                                        {{ item.channelWay }}
                                    </div>
                                    <div class="channel-flex">
                                        <h4>时间：</h4>
                                        {{ item.createTime }}
                                    </div>
                                </el-row>
                                <div class="right-btn-container">
                                    <el-button class="padding0" type="text" @click="toVoid(item)">作废</el-button>
                                    <el-button class="padding0" type="text" @click="openPrintPage(item)">打印({{ item.printfCount || 0}})</el-button>
                                    <!-- <el-button class="padding0" type="text">明细</el-button> -->
                                </div>
                            </el-row>
                        </el-card>
                    </div>

                    <!-- <el-row>
                        <el-col :span="12" v-for="item in infoChannel" :key="item.id">
                            <el-card shadow="never">
                                <div class="inform">
                                    <span>国际运单号：{{ item.conveyNumber }}</span>
                                    <span class="margin-left4">国际转单号：</span>
                                </div>
                                <div class="inform">路线：{{ item.channelWay }}</div>
                                <div class="right-btn-container">
                                    <el-button class="padding0" type="text">打印(0)</el-button>
                                    <el-button class="padding0" type="text">明细</el-button>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row> -->
                </div>
            </div>


        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="infoCheckDone" :loading="isDoneBtnLoding">完 成</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
import { printInfo, increaseNum } from '@/utils/common.js'
import axios from 'axios'
export default {
    name: "Informationcheck",
    props: {
        bagList: {
            type: Array,
            default() {
                return [];
            },
        }
    },
    data() {
        return {
            dialogVisible: false,
            infoData: {},
            isDoneBtnLoding: false,
            bagLists:[]
        };
    },
    computed: {
        infoContent() {
            return Object.keys(this.infoData).length && this.infoData.purchases[0];
        },
        infoPurchase() {
            return Object.keys(this.infoData).length && this.infoData.purchases;
        },
        infoChannel() {
            return Object.keys(this.infoData).length && this.infoData.orderChannels;
        },
    },
    methods: {
        async openPrintPage(item) {
            if (item.type == 12) {
                window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
            } else if (item.type == 13) {
                window.open('http://129.204.214.77:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
            } else if (item.type == 15 || item.type == 16) {
                if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
                    window.open(item.conveyNumberUrl);
                } else {
                    this.$message.error('暂无面单！')
                }
            } else if (item.type == 17) {
                window.open('http://47.96.42.132:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
            } else if (item.type == 18) {
                let API = Baseurl + 'baidian_order/getOrderLable'
                ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                window.open(res.data)
                })
            } else if (item.type == 19) {
                let API = Baseurl + 'wanLeaderTypeController/getWanLeaderLabal'
                ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                let data = JSON.parse(res.data)
                window.open(data.data)
                })
            } else if (item.type == 20) {
                window.open('http://1.14.254.116:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
            } else if (item.type == 21) {
                window.open('http://106.52.235.113:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
            } else if (item.type == 22) {
                let API = Baseurl + 'jiTuTypeController/getPrintUrl'
                ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                    let data = JSON.parse(res.data)
                    window.open(data.data)
                })
            } else if (item.type == 23) {
                let API = Baseurl + 'udaTypeController/getUdaLabal'
                ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                    let data = JSON.parse(res.data)
                    window.open(data.data)
                })
            } else if (item.type == 25 || item.type == 26) {
                if (item.conveyNumberUrl != null && item.conveyNumberUrl != ''){
                    window.open(item.conveyNumberUrl);
                } else {
                    window.open('http://159.75.205.97:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
                }
            } else if (item.type == 27) {
                if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
                    window.open(item.conveyNumberUrl);
                } else {
                    let API = Baseurl + 'dealfyController/getWaybill'
                    ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                        let data = JSON.parse(res.data)
                        window.open(data.data)
                    })
                }
            } else if (item.type == 28) {
                if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
                    window.open(item.conveyNumberUrl);
                    } else {
                    let API = Baseurl + 'cainiaoOrderController/getWaybill'
                    ajaxPost(API, { conveyNumber: item.conveyNumber, type: 28 }, { responseType: 'blob' }).then((res) => {
                        let data = JSON.parse(res.data)
                        window.open(data.data)
                    })
                }
            } else if (item.type == 29) {
                if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
                window.open(item.conveyNumberUrl);
                }
            } else if (item.type == 31) {
                if (item.conveyNumberUrl != null && item.conveyNumberUrl != '') {
                    window.open(item.conveyNumberUrl);
                    } else {
                    let API = Baseurl + 'cainiaoOrderController/getWaybill'
                    ajaxPost(API, { conveyNumber: item.conveyNumber, type: 31 }, { responseType: 'blob' }).then((res) => {
                        let data = JSON.parse(res.data)
                        window.open(data.data)
                    })
                }
            } else if (item.type == 30) {
                window.open('http://43.139.202.31:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
            } else if (item.type == 32) {
                if (item.channelWayEn == 'AE_GLOBAL_JIT') {
                    let API = Baseurl + 'aliexpressSemiHostingCollection/getShippingMarkPdf'
                    ajaxPost(API, { sellerId: this.infoData.sellerId, purchaseOrderNo: item.fulfillmentId }, { responseType: 'blob' }).then((res) => {
                        let data = JSON.parse(res.data)
                        window.open(data.data)
                    })
                } else {
                    let API = Baseurl + 'aliexpressLogistics/getPrintinfo'
                    ajaxPost(API, { international_logistics_id: item.conveyNumber, sellerId: this.infoData.sellerId }, { responseType: 'blob' }).then((res) => {
                        let data = JSON.parse(res.data)
                        window.open(data.data)
                    })
                }
            } else if (item.type == 33) {
                let API = Baseurl + 'walmartShipping/downloadLabel'
                // console.log(this.infoData);
                ajaxPost(API, { sellerId: this.infoData.sellerId, trackingNo: item.conveyNumber, carrierShortName: item.channelName }, { responseType: 'blob' }).then((res) => {
                let data = JSON.parse(res.data)
                window.open(data.data)
                })
            } else if (item.type == 34) {
                let API = Baseurl + 'shangYiTypeController/getOrderLabel'
                ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                let data = JSON.parse(res.data)
                window.open(data.data)
                })
            } else if (item.type == 35) {
                let API = Baseurl + 'xiaoBaoTypeController/getOrderLabel'
                ajaxPost(API, { conveyNumber: item.conveyNumber }, { responseType: 'blob' }).then((res) => {
                    let data = JSON.parse(res.data)
                    window.open(data.data)
                })
            } else if (item.type == 36) {
                if (item.conveyNumberUrl) {
                    let API = Baseurl + 'mercadolibre/getWaybill'
                    axios.post(API,
                        { url: item.conveyNumberUrl, sellerId: item.sellerId },
                        { responseType: 'arraybuffer' }  // ← 关键
                    ).then((res) => {
                        const blob = new Blob([res.data], { type: 'application/pdf' })
                        window.open(URL.createObjectURL(blob))
                    })
                } else {
                    this.$message.info('该订单暂无数据！')
                }
            } else {
                await printInfo(item)
            }
			// if(item.type != 12) {
			// 	await printInfo(item)
			// }else{
			// 	window.open('http://159.75.210.47:8089/order/FastRpt/PDF_NEW.aspx?PrintType=lab10_10&order_id=' + item.channelId)
			// }
            await increaseNum(item)
			item.printfCount += 1
        },
        init(row) {
            this.dialogVisible = true;
            this.ids = {
                id: row.id,
                orderId: row.orderId
            }
            for(var i=0;i<this.bagList.length;i++){
                if(this.bagList[i].sellerType===row.source){
                    this.bagLists.push(this.bagList[i]);
                }
            }
            console.log(this.bagLists);
            this.renderComponent=true;
            this.getInfo();
        },
        close() {
            this.dialogVisible = false;
            this.isDoneBtnLoding = false;
            this.infoData = {};
        },
        getInfo() {
            const API = Baseurl + "logisticsController/getOrderDetailsById";
            const paramsData = {
                purchaseDemandId: this.ids.id,
            };
            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    this.infoData = data;
                    console.log(data);
                }
            });
        },
        infoCheckDone() {
            const data = {
                orderPackPrices: this.infoData.orderPackPrices,
                ...this.ids
            }
            this.$confirm("点击完成之后将无法打印运单，是否确定？", "提示").then(() => {
                this.isDoneBtnLoding = true;
                this.$emit("confirm", data);
            });
        },
        calcPrice(item) {
            let { packId, packCount = 1 } = item;
            console.log(packId);
            if (!packId) return 0;
            const price = this.bagList.find(item => item.id === packId).priceValue;
            return price * packCount;
        },
        Add_Packing_materials() {
            const param = {
                orderId: this.ids.orderId,
                packId: "",
                packCount: 1
            };
            this.infoData.orderPackPrices.push(param);
        },
        Packingmaterialsdele(index) {
            if (this.infoData.orderPackPrices.length > 1) {
                this.infoData.orderPackPrices.splice(index, 1);
                this.$message("删除成功");
            } else {
                this.$message("此包材设置必须最少保留1条");
            }
        }
    },
};
</script>
<style lang="scss" scoped>
.custom-container {
    padding: 0 20px;
    display: flex;
    align-items: center;
}
.inform {
    line-height: 30px;
    &.flex {
        display: flex;
        .title {
            flex-shrink: 0;
            font-weight: bold;
        }
    }
}
.right-btn-container {
    display: flex;
    justify-content: flex-end;
}
.el-popover {
    position: absolute;
    background: #fff;
    min-width: 200px;
    border: 1px solid #ebeef5;
    padding: 12px;
    left: 40%;
    right: 0%;
    top: -17%;
    color: #606266;
    line-height: 1.4;
    text-align: justify;
    font-size: 14px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: none;
    z-index: 9998;
    img {
        width: 90%;
    }
}
.padding0 {
    padding: 0;
}
.channel-flex {
    display: flex;
    margin-right: 20px;
}
</style>
